import React, { useState, useCallback } from "react";
import { PermitTypeCardContent, PermitTypeWithZones } from "./PermitTypeCardContent";

export interface PermitTypeCardProps {
  permitType: PermitTypeWithZones;
  isSelected: boolean;
  onSelect: (permitType: PermitTypeWithZones) => void;
  onViewZones: (permitType: PermitTypeWithZones) => void;
}

export const PermitTypeCard: React.FC<PermitTypeCardProps> = ({ permitType, isSelected, onSelect, onViewZones }) => {
  const [isDocsExpanded, setIsDocsExpanded] = useState(false);

  const handleCardClick = useCallback(() => {
    onSelect(permitType);
  }, [onSelect, permitType]);

  const handleDocsToggle = useCallback(() => {
    setIsDocsExpanded((prev) => !prev);
  }, []);

  const handleViewZonesClick = useCallback(() => {
    onViewZones(permitType);
  }, [onViewZones, permitType]);

  return (
    <PermitTypeCardContent
      permitType={permitType}
      isSelected={isSelected}
      isDocsExpanded={isDocsExpanded}
      onCardClick={handleCardClick}
      onDocsToggle={handleDocsToggle}
      onViewZonesClick={handleViewZonesClick}
    />
  );
};

export default PermitTypeCard;
